export const RESERVATION_ACTION_TIMEOUT = 1000 * 2 * 60;
